import { render, staticRenderFns } from "./HighlightCatalog.vue?vue&type=template&id=6718925e&scoped=true"
import script from "./HighlightCatalog.vue?vue&type=script&lang=js"
export * from "./HighlightCatalog.vue?vue&type=script&lang=js"
import style0 from "./HighlightCatalog.vue?vue&type=style&index=0&id=6718925e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6718925e",
  null
  
)

export default component.exports